import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const PartnerDashboard = lazy(() => import("@/pages/partner/PartnerDashboard"));

export const Route = createFileRoute("/partner/")({
  head: () => ({
    meta: [
      { title: "Partnerportal – Elmarknad.se" },
      { name: "description", content: "Översikt över era leads och er statistik hos Elmarknad.se." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => <PartnerDashboard />,
});
